import icon from "images/layout/chevron-down.svg"
import parse from "html-react-parser"

export default function ChevronDownIcon() {
  return (
    <span className="svg-icon">{parse(icon)}</span>
  )
}
